type PriceCandidate = number | string | null | undefined;

const toFiniteNumber = (value: PriceCandidate): number | undefined => {
  if (value === null || value === undefined) return undefined;
  const num = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(num) ? num : undefined;
};

/**
 * Prefer orderbook ask when present, but preserve legitimate 0 values.
 * Only fall back to static price when ask is truly missing/invalid.
 */
export const getPreferredOutcomeDisplayPrice = (
  bestAsk: PriceCandidate,
  fallbackPrice: PriceCandidate,
  options?: {
    bestBid?: PriceCandidate;
    isClosed?: boolean;
  }
): number | undefined => {
  const askNum = toFiniteNumber(bestAsk);
  const fallbackNum = toFiniteNumber(fallbackPrice);
  if (askNum !== undefined) {
    const bidNum = toFiniteNumber(options?.bestBid);
    const isClosed = options?.isClosed === true;
    // Preserve PM behavior for effectively non-tradable books while
    // avoiding false 0s when static price still carries a meaningful signal.
    if (!isClosed && askNum >= 0.999 && (bidNum === undefined || bidNum <= 0)) {
      if (fallbackNum !== undefined) {
        if (fallbackNum <= 0.01) return 0;
        return fallbackNum;
      }
      return 0;
    }
    return askNum;
  }
  return fallbackNum;
};
